import View from "./View";

const ContactUs = ({ project, onNext, onBack, isAuraTer = false }) => {
  const next = () => onNext({});

  return (
    <View
      project={project}
      onNext={next}
      onBack={onBack}
      isAuraTer={isAuraTer}
    />
  );
};

export default ContactUs;
